var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRequests(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 37,
    viewBox: "0 0 29 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H19.0035L28.3333 10.1531V37H0V0ZM2.83333 3.08333V33.9167H25.5V13.875H15.5833V3.08333H2.83333ZM18.4167 3.72191V10.7917H24.9132L18.4167 3.72191ZM12.75 13.875H5.66667V10.7917H12.75V13.875ZM22.6667 20.0417H5.66667V16.9583H22.6667V20.0417ZM19.8333 23.125V26.2083H5.66667V23.125H19.8333Z",
    fill: "#007DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequests);
export default __webpack_public_path__ + "static/media/requests.4badb5e1ae06fa7d8a321ed490069bdc.svg";
export { ForwardRef as ReactComponent };